import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NAV_ITEMS: { to: string; label: string }[] = [
  { to: 'stats', label: 'Estadísticas' },
  { to: 'gospel', label: 'Evangelio del día' },
  { to: 'gospel-archivo', label: 'Archivo de evangelios' },
  { to: 'events', label: 'Eventos' },
  { to: 'prayers', label: 'Oraciones' },
  { to: 'resources', label: 'Recursos' },
  { to: 'news', label: 'Noticias' },
  { to: 'courses', label: 'Formación' },
  { to: 'podcast-programs', label: 'Programas de podcast' },
  { to: 'podcast', label: 'Episodios de podcast' },
  { to: 'meditations', label: 'Meditaciones' },
  { to: 'musica-cine', label: 'Música y Cine' },
  { to: 'missionary', label: 'Crear misionero' },
  { to: 'missionaries', label: 'Misioneros' },
  { to: 'inscriptions', label: 'Inscripciones' },
  { to: 'notify', label: 'Notificaciones' },
  { to: 'rosario', label: 'Rosario' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="sidebar-header">
          <p className="sidebar-title">Panel Admin</p>
          <p className="sidebar-sub">Evangelización Digital · Huelva</p>
        </div>
        <nav>
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="user-name">{user?.name || user?.email}</div>
          <div>{user?.email}</div>
          <button className="logout-btn" onClick={logout}>Cerrar sesión</button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
